import { trackNormalComponent } from '@drone-js/core';
import { WeekDisplay } from './WeekDisplay.js';

var WeekDisplayWithTracking = trackNormalComponent(WeekDisplay, {
  addWrapper: true
});

export { WeekDisplayWithTracking as WeekDisplay };
//# sourceMappingURL=external.js.map
